jQuery(document).ready(function () {
  if (jQuery("body").attr("id") !== "dashboard") {
    return;
  }

  var rows = jQuery(".assignments tr");
  rows.slice(5).hide();

  jQuery(".toggle").on("click", function () {
    if (jQuery(this).hasClass("less")) {
      rows.slice(5).hide();
      jQuery(this).removeClass("less");
      jQuery(this).html("View more");
    } else {
      rows.show();
      jQuery(this).addClass("less");
      jQuery(this).html("View less");
    }
  });
});
